import { BraintreeError, Client, client } from "braintree-web";

type CardType = any;
type ErrorCallback = (error: BraintreeError) => any;
type SuccessCallback = (response: any) => any;

export const useBraintree = () => {
  class Braintree {
    onError;
    onSuccess;
    constructor(onError: ErrorCallback, onSuccess: SuccessCallback) {
      this.onError = onError;
      this.onSuccess = onSuccess;
    }

    async payment(token: string, creditCard: CardType) {
      return await new Promise((resolve, reject) => {
        client.create(
          { authorization: token },
          (error?: BraintreeError, client?: Client) => {
            if (error) reject(error);
            const endpoint = "payment_methods/credit_cards";
            const method = "post";
            const data = { creditCard };
            const callback = (error?: BraintreeError, response?: any) => {
              if (error) reject(error);
              return resolve(response);
            };
            client?.request({ endpoint, method, data }, callback);
          }
        );
      })
        .then((res) => this.onSuccess(res))
        .catch((err) => this.onError(err));
    }
  }

  const braintreePayment = async (options: {
    token: string;
    creditCard: CardType;
    onError: ErrorCallback;
    onSuccess: SuccessCallback;
  }) => {
    const braintree = new Braintree(options.onError, options.onSuccess);
    await braintree.payment(options.token, options.creditCard);
  };

  return { braintreePayment };
};
